import { render, staticRenderFns } from "./GroupsCard.vue?vue&type=template&id=1341997a&"
import script from "./GroupsCard.vue?vue&type=script&lang=js&"
export * from "./GroupsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports